// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AvatarWithFullScreen__button-bc2099 {
  display: block;
  cursor: pointer;
}

.AvatarWithFullScreen__button-bc2099:disabled {
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/Avatar/AvatarWithFullScreen/AvatarWithFullScreen.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".button {\n  display: block;\n  cursor: pointer;\n}\n\n.button:disabled {\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `AvatarWithFullScreen__button-bc2099`
};
module.exports = ___CSS_LOADER_EXPORT___;
